import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";

const ProductCard = ({ product, handleAddToCart }) => {
  return (
    <Card variant="outlined" className = "card" >
      <CardMedia
        component="img"
        height="50%"
        image={product.image}
        alt="green iguana"
      />

    <CardContent>
      <Typography gutterBottom variant="h6"  color="text.secondary" className="product-title">
        {product.name}
      </Typography>
      <Typography gutterBottom variant="h5" className="product-cost">
        ${product.cost}
      </Typography>
      <Rating  name="read-only" value={product.rating} readOnly />
    </CardContent>

    <CardActions className="card-actions">
        <Button  className="card-button" variant="contained" fullWidth startIcon={<AddShoppingCartOutlined />} onClick={handleAddToCart}>ADD TO CART</Button>
    </CardActions>

  </Card>
  );
};

export default ProductCard;

/**
 * 
{
"name":"Tan Leatherette Weekender Duffle",
"category":"Fashion",
"cost":150,
"rating":4,
"image":"https://crio-directus-assets.s3.ap-south-1.amazonaws.com/ff071a1c-1099-48f9-9b03-f858ccc53832.png",
"_id":"PmInA797xJhMIPti"
}
 */
